import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Shield, MapPin } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_3885f60a-e4ce-4e7e-b71d-89edd5337d92/artifacts/2dlizjmm_Gemini_Generated_Image_1lmywa1lmywa1lmy.jpeg';

const FooterSection = () => {
  const { t } = useTranslation();

  return (
    <footer className="py-16 bg-brand-forest text-brand-paper">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img
                src={LOGO_URL}
                alt="ProposAI logo"
                className="w-8 h-8 rounded-md object-contain bg-white p-0.5"
              />
              <span className="text-xl font-bold text-white">ProposAI</span>
            </div>
            <p className="text-sm mb-3 text-brand-paper/70">
              {t('landing.footer.tagline')}
            </p>
            <div className="flex items-center gap-1.5 text-xs mb-4 text-brand-paper/70">
              <MapPin className="w-3 h-3" />
              <span>Made in Canada — For Canadian Businesses</span>
            </div>
            {/* Proof chip */}
            <div className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 bg-primary/40 border border-primary/50 text-brand-paper rounded-full">
              <Shield className="w-3 h-3" />
              {t('landing.trust.proofChip')}
            </div>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-white font-semibold mb-4">{t('landing.footer.product')}</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a 
                  href="/#how-it-works" 
                  className="transition-colors text-brand-paper/70 hover:text-white"
                >
                  {t('landing.nav.howItWorks')}
                </a>
              </li>
              <li>
                <a 
                  href="/#pricing" 
                  className="transition-colors text-brand-paper/70 hover:text-white"
                >
                  {t('landing.nav.pricing')}
                </a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-white font-semibold mb-4">Resources</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link 
                  to="/faq" 
                  className="transition-colors text-brand-paper/70 hover:text-white"
                >
                  FAQ
                </Link>
              </li>
              <li>
                <Link 
                  to="/resources" 
                  className="transition-colors text-brand-paper/70 hover:text-white"
                >
                  Procurement Guides
                </Link>
              </li>
            </ul>
          </div>

          {/* Trust & Legal */}
          <div>
            <h4 className="text-white font-semibold mb-4">Trust & Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link 
                  to="/trust" 
                  className="flex items-center gap-1.5 transition-colors text-brand-paper/70 hover:text-white"
                >
                  <Shield className="w-3 h-3" />
                  Trust Center
                </Link>
              </li>
              <li>
                <Link 
                  to="/privacy-policy" 
                  className="transition-colors text-brand-paper/70 hover:text-white"
                >
                  {t('landing.footer.privacy')}
                </Link>
              </li>
              <li>
                <Link 
                  to="/terms" 
                  className="transition-colors text-brand-paper/70 hover:text-white"
                >
                  {t('landing.footer.terms')}
                </Link>
              </li>
              <li>
                <a 
                  href="mailto:info@proposai.ca" 
                  className="transition-colors text-brand-paper/70 hover:text-white"
                >
                  {t('landing.footer.contact')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-brand-paper/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-brand-paper/70">
              {t('landing.footer.copyright')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
